import { arrayOf, node, number, string } from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components";

import { motion } from "framer-motion";

import useGradiant from "Utilities/Colors/useGradiant";
import useIsTallerThan from "Utilities/Hooks/useIsTallerThan";

const ColorDiv = styled(motion.div)`
  width: 100%;
  height: 100%;
  ${({ $minHeight, $shouldScroll }) =>
    $shouldScroll ? `min-height: ${$minHeight}px;` : ""};
  position: fixed;
  ${({ $shouldScroll }) => ($shouldScroll ? "overflow-y: scroll;" : "")}
`;

const FnrFullPageColor = forwardRef(
  ({ colorScheme, children, minHeight = 560, ...rest }, ref) => {
    const background = useGradiant({
      colors: colorScheme,
    });

    const shouldScroll = !useIsTallerThan(ref, { px: minHeight });

    return (
      <ColorDiv
        initial={false}
        animate={{
          backgroundImage: background,
          transition: { duration: 0.6 },
        }}
        ref={ref}
        $minHeight={minHeight}
        $shouldScroll={shouldScroll}
        {...rest}
      >
        {children}
      </ColorDiv>
    );
  }
);

FnrFullPageColor.propTypes = {
  colorScheme: arrayOf(string),
  children: node,
  minHeight: number,
};

export default FnrFullPageColor;
